import React from 'react'
import Page from 'src/components/Page'
import { Grid, Box } from '@material-ui/core'
import FilesTable from './FilesTable'
import CollapsibleKitsAndPanelsTable from './CollapsibleKitsAndPanelsTable'
import UnifiedFileUpload from './UnifiedFileUpload'
import FilesDashboard from './FilesDashboard'

const UploadView = function () {
  return (
    <Page title="Upload File | Genesus">
      <Grid container spacing={3} sx={{ mt: 1 }}>
        {/* First row: upload and stats share a height; both grow with their content above 550px */}
        <Grid item xs={12} lg={5}>
          <Box
            sx={{
              height: '100%',
              minHeight: 550,
              display: 'flex',
              flexDirection: 'column',
              '& > *': {
                height: '100%',
              },
            }}
          >
            <UnifiedFileUpload />
          </Box>
        </Grid>

        <Grid item xs={12} lg={7}>
          <Box
            sx={{
              height: '100%',
              minHeight: 550,
              display: 'flex',
              flexDirection: 'column',
              '& > *': {
                height: '100%',
              },
            }}
          >
            <FilesDashboard />
          </Box>
        </Grid>

        {/* Second row for file and kit tables */}
        <Grid item xs={12}>
          <FilesTable />
        </Grid>

        <Grid item xs={12}>
          <CollapsibleKitsAndPanelsTable />
        </Grid>
      </Grid>
    </Page>
  )
}

export default UploadView
